import { useEffect } from 'react'
import {
    InterestedValues,
    PresentCandidateValues,
} from '../../api/role/models/CandidateDto'
import Button from '../Button'
import DropDown from '../DropDown'
import { useManageRoleStore } from './stateStore/manageRoleStore'

interface CandidateFiltersProps {
    defaultPresentFilter?: PresentCandidateValues | 'all' | 'none'
    defaultOrderBy?: 'combined' | 'jobRelevanceOnly' | 'networkClosenessOnly'
    hidePresentFilter?: boolean
    hideOrderByFilter?: boolean
}

export default function CandidateFilters({
    defaultPresentFilter,
    defaultOrderBy,
    hidePresentFilter = false,
    hideOrderByFilter = false,
}: CandidateFiltersProps) {
    const presentFilter = useManageRoleStore((state) => state.presentFilter)
    const interestedFilter = useManageRoleStore(
        (state) => state.interestedFilter,
    )
    const setPresentFilter = useManageRoleStore(
        (state) => state.setPresentFilter,
    )
    const setInterestedFilter = useManageRoleStore(
        (state) => state.setInterestedFilter,
    )
    const orderBy = useManageRoleStore((state) => state.orderBy)
    const setOrderBy = useManageRoleStore((state) => state.setOrderBy)
    const clearCandidates = useManageRoleStore((state) => state.clearCandidates)
    const fetchNextCandidates = useManageRoleStore(
        (state) => state.fetchNextCandidates,
    )

    useEffect(() => {
        if (defaultPresentFilter) setPresentFilter(defaultPresentFilter)
        if (defaultOrderBy) setOrderBy(defaultOrderBy)

        clearCandidates()
        fetchNextCandidates()
    }, [])

    return (
        <div className="mt-4 flex gap-4 flex-wrap">
            {!hidePresentFilter && (
                <DropDown
                    id="filter-present"
                    name="Filter by Shortlisted:"
                    items={[
                        { id: 'all', value: 'All' },
                        { id: 'yes', value: 'Yes' },
                        { id: 'no', value: 'No' },
                        { id: 'none', value: 'None' },
                    ]}
                    selectedItemId={presentFilter}
                    onItemSelected={(selectedItemId) =>
                        setPresentFilter(
                            selectedItemId as PresentCandidateValues | 'all',
                        )
                    }
                />
            )}
            {!hideOrderByFilter && (
                <DropDown
                    id="order-by"
                    name="Order By:"
                    items={[
                        { id: 'combined', value: 'Combined' },
                        { id: 'jobRelevanceOnly', value: 'Job Relevance Only' },
                        {
                            id: 'networkClosenessOnly',
                            value: 'Network Closeness Only',
                        },
                    ]}
                    selectedItemId={orderBy}
                    onItemSelected={(selectedItemId) =>
                        setOrderBy(
                            selectedItemId as
                                | 'combined'
                                | 'jobRelevanceOnly'
                                | 'networkClosenessOnly',
                        )
                    }
                />
            )}
            <DropDown
                id="filter-interested"
                name="Filter by Interested:"
                items={[
                    { id: 'all', value: 'All' },
                    { id: 'yes', value: 'Yes' },
                    { id: 'no', value: 'No' },
                    { id: 'none', value: 'None' },
                ]}
                selectedItemId={interestedFilter}
                onItemSelected={(selectedItemId) =>
                    setInterestedFilter(
                        selectedItemId as InterestedValues | 'all',
                    )
                }
            />

            <Button
                type="button"
                style="primary"
                onClick={() => {
                    clearCandidates()
                    fetchNextCandidates()
                }}
            >
                Apply
            </Button>
        </div>
    )
}
